import {
  Grid,
  Box,
  TextField,
  Button,
  Switch,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { EditorCkMain } from "../../components/CkEditor";
import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";
import { Loading } from "../../components/shared/loading";
import { JOB_TYPES, WORK_TYPES } from "./addjob";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

export const UpdateJob = () => {
  const classes = useAdminStyles();
  const navigate = useNavigate();
  const toast = useToast();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [jobType, setJobType] = useState("full_time");
  const [workType, setWorkType] = useState("location");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(true);
  const [err, setErr] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);
    Axios.post("/api/admin/getjob", fd, { headers: { headKey } }).then((res) => {
      if (res.data.status && res.data.data) {
        const d = res.data.data;
        setTitle(d.title || "");
        setJobType(d.job_type || "full_time");
        setWorkType(d.work_type || "location");
        setLocation(d.location || "");
        setDescription(d.description || "");
        setStatus(d.status === "show");
      } else {
        toast.error("Job not found.");
        navigate("/dash/alljobs");
      }
      setLoading(false);
    });
  }, [id]);

  const onSubmit = () => {
    setErr(0);
    if (!title.trim()) {
      setErr(1);
      toast.error("Please enter a job title.");
      return;
    }
    if (!description || !description.trim()) {
      setErr(2);
      toast.error("Please enter the job description.");
      return;
    }
    setSubmitting(true);
    const fd = new FormData();
    fd.append("id", id);
    fd.append("title", title.trim());
    fd.append("job_type", jobType);
    fd.append("work_type", workType);
    fd.append("location", location.trim());
    fd.append("description", description);
    fd.append("status", status ? "show" : "hide");
    Axios.post("/api/admin/update_job", fd, { headers: { headKey } })
      .then((res) => {
        setSubmitting(false);
        if (res.data.status) {
          toast.success(res.data.msg || "Job updated");
          navigate("/dash/alljobs");
        } else {
          toast.error(res.data.msg || "Something went wrong.");
        }
      })
      .catch(() => {
        setSubmitting(false);
        toast.error("Network error. Please try again.");
      });
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Edit Job - Admin | Arawinz Soft Solutions</title>
      </Helmet>
      <AdminPageHeader
        eyebrow="Jobs"
        title="Edit job"
        subtitle="Update this opening on the careers page."
        backTo="/dash/alljobs"
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Job title"
            variant="outlined"
            error={err === 1}
            value={title}
            size="small"
            onChange={(e) => setTitle(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Job type"
            variant="outlined"
            value={jobType}
            size="small"
            onChange={(e) => setJobType(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            {JOB_TYPES.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            label="Work type"
            variant="outlined"
            value={workType}
            size="small"
            onChange={(e) => setWorkType(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            {WORK_TYPES.map((o) => (
              <MenuItem key={o.value} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Location"
            variant="outlined"
            value={location}
            size="small"
            onChange={(e) => setLocation(e.target.value)}
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Box className={classes.statusRow}>
            <Switch
              checked={status}
              onChange={() => setStatus(!status)}
              color="primary"
            />
            <span>
              Status:{" "}
              <span className={status ? "on" : "off"}>
                {status ? "Shown" : "Hidden"}
              </span>
            </span>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Typography className={classes.sectionTitle}>Description</Typography>
          <EditorCkMain desc={description} setDescr={(e) => setDescription(e)} />
        </Grid>
      </Grid>

      <Box className={classes.formFooter}>
        <Button
          className={classes.secondaryBtn}
          onClick={() => navigate("/dash/alljobs")}
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitting}
          className={classes.primaryBtn}
          endIcon={!submitting && <ArrowForwardIcon />}
        >
          {submitting ? "Saving..." : "Save Changes"}
        </Button>
      </Box>
    </div>
  );
};
